/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceDetailsOverview {
    getFixupPrototypeFunction() { return ResourceDetailsOverview.fixupPrototype; }

    static newInstance(model: Partial<ResourceDetailsOverview>): ResourceDetailsOverview {
        let obj = Object.assign(new ResourceDetailsOverview(), model);
        ResourceDetailsOverview.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceDetailsOverview>): ResourceDetailsOverview {
        if (!model) return null;
        return ResourceDetailsOverview.newInstance(<ResourceDetailsOverview> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceDetailsOverview) {
        if (!obj) return;

        models.ResourceDetailsOverview.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceDetailsOverview): boolean {
        Object.setPrototypeOf(obj, ResourceDetailsOverview.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cpu) {
            for (let val of this.cpu) {
                models.ResourceRecord.fixupPrototype(val);
            }
        }
        if (this.memory) {
            for (let val of this.memory) {
                models.ResourceRecord.fixupPrototype(val);
            }
        }
    }

    /**
     * Resource Details By CPU
     */
    cpu: Array<models.ResourceRecord>;

    /**
     * Resource Details by Memory
     */
    memory: Array<models.ResourceRecord>;

}
